import "./subpage-header.scss";
import React from "react";
import { Link } from "gatsby";
import useTranslation from "locales";

const SubpageHeader = ({ title, back, variant, lang }) => {
  const { t } = useTranslation(lang);
  return (
    <div className="subpage-header">
      <div className="container">
        <h1
          className={
            variant
              ? "subpage-header__title subpage-header__title--variant"
              : "subpage-header__title"
          }
        >
          {title}
        </h1>
        {back && (
          <Link
            to={back}
            className="link-line link-line--reversed subpage-header__btn"
          >
            {t("Powrót")}
          </Link>
        )}
      </div>
    </div>
  );
};

export default SubpageHeader;
